import { Button, Tooltip } from "antd"
import helpIcon from "../../assets/images/icon_question.svg"
import refreshIcon from "../../assets/images/icon_refresh.svg"
import pdfIcon from "../../assets/images/icon_pdffile.svg"
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"

/**
 *  @param {*} props 
    @param {function} props.handleDocument action to handle the documentation button selection
    @param {String}   props.documentButtonText text displayed on the documentation button
    @param {function} props.handleRefresh action to handle the refresh button selection
    @param {function} props.handleHelpReq action to handle the help button selection
    @param {Array[String]} props.contentItems Array of extra buttons/HTML element to be shown ["refresh", "help"]
        @example ["help"]
    @returns {React.ReactNode} returns a reactNode to display Extra Tab contents - Refresh & Help buttons
 */

const TabExtraContent = (props) => {

    const [extraContent, setExtraContent] = useState([])
    const dict = useSelector((state) => state.common.dict)

    useEffect(() => {
        let extContent = []
        if (props.items?.length)
            extContent = props.items?.find(item => item.key === props.selectedTab)?.extraContent
        else
            extContent = props.contentItems

        setExtraContent(extContent)
    }, [props.selectedTab, props.items, props.contentItems])
    

    return <span className="extra-tab-content">
        {extraContent?.includes("document") ? 
            <Button 
                shape="default" 
                type="primary" 
                className="extra-tab-actions"  
                icon={<img src={pdfIcon} alt="Pdf icon" width="17px" />}
                onClick={() => props.handleDocument()} >
                {props.documentButtonText}
            </Button> : <></>}

        {extraContent?.includes("refresh") ? <Tooltip title={getTranslated(dict, "LABEL_REFRESH")}>
            <Button
                shape="circle"
                className="extra-tab-actions"
                icon={<img src={refreshIcon} alt="Refresh icon" />}
                onClick={() => props.handleRefresh()}
            />
        </Tooltip> : <></>}

        {extraContent?.includes("help") ? <Tooltip title={getTranslated(dict, "LABEL_HELP")}>
            <Button
                shape="circle"
                className="extra-tab-actions"
                icon={<img src={helpIcon} alt="Help icon" />}
                onClick={() => props.handleHelpReq()}
            />
        </Tooltip> : <></>}

        {
            // Add other possible sub-header/tab content actions
        }
    </span>
}

export default TabExtraContent